import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center 2xl:pt-[40px] justify-center min-h-[80vh] px-6 text-center bg-white">
      {/* THE SEO SHIELD: Tell Google to ignore this URL forever */}
      <Helmet>
        <title>Page Not Found | Sitemanifest</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <h1 className="text-[120px] font-staat text-[#08696D] leading-none">404</h1>
      
      <h2 className="text-[24px] font-staat text-[#323232] uppercase tracking-wider mt-4">
        Lost in the Manifest
      </h2>
      
      <p className="text-[#666] font-poppins max-w-[400px] mt-2 mb-8 text-[14px] lg:text-[16px]">
        The page you are looking for doesn't exist or has been moved. 
        All interactions on Sitemanifest must be authenticated.
      </p>

      <div className="flex flex-col sm:flex-row gap-4">
        <button 
          onClick={() => navigate('/')}
          className="bg-[#08696D] text-white px-8 py-3 rounded font-staat hover:shadow-lg active:scale-95 transition-all uppercase tracking-widest"
        >
          Return Home
        </button>
        
        <button 
          onClick={() => navigate(-1)} // Takes them back to where they actually were
          className="border-2 border-[#08696D] text-[#08696D] px-8 py-3 rounded font-staat hover:bg-gray-50 active:scale-95 transition-all uppercase tracking-widest"
        >
          Go Back
        </button>
      </div>
    </div>
  );
}